import { api_ } from '@shared/plugIn/axios';
import { LowerRole } from '@shared/types';

import {
  GiftItemInfo,
  GiftItemInfoCreate,
  GiftItemInfoUpdate,
} from './giftItemInfo.interface';

export const getGiftItemInfoList = async (role: LowerRole) => {
  const { data } = await api_.get<GiftItemInfo[]>(
    `${role}/gift-item-info?populate=["image","detailImages","deliveredImageList"]`,
  );
  return data;
};

export const getGiftItemInfo = async (id: string, role: LowerRole) => {
  const { data } = await api_.get<GiftItemInfo>(
    `${role}/gift-item-info/${id}?populate=["image","detailImages","deliveredImageList"]`,
  );
  return data;
};

export const createGiftItemInfo = async (
  giftItemInfo: GiftItemInfoCreate,
  role: LowerRole,
) => {
  const { data } = await api_.post<GiftItemInfo>(`${role}/gift-item-info`, giftItemInfo);
  return data;
};

export const updateGiftItemInfo = async (
  giftItemInfo: GiftItemInfoUpdate,
  role: LowerRole,
) => {
  const { data } = await api_.patch<GiftItemInfo>(
    `${role}/gift-item-info/${giftItemInfo._id}`,
    giftItemInfo,
  );
  return data;
};

//* 활성/비활성 일괄 변경 — 제네릭 PATCH(updateMany) 1회 호출. body에 _id를 넣으면 안 됨(불변 필드 에러)
export const bulkSetGiftItemInfoEnabled = async (
  ids: string[],
  isEnabled: boolean,
  role: LowerRole,
) => {
  const filter = encodeURIComponent(JSON.stringify({ _id: { $in: ids } }));
  const { data } = await api_.patch<{ matchedCount?: number; modifiedCount?: number }>(
    `${role}/gift-item-info?filter=${filter}`,
    { isEnabled },
  );
  return data;
};

export const deleteGiftItemInfo = async (id: string, role: LowerRole) => {
  const { data } = await api_.delete(`${role}/gift-item-info/${id}`);
  return data;
};
